import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { ListItemState, useListContext } from '../context/ListContext';
import { getMargin, getPadding } from '../utils/spacing';

type ListItemProps = ListItemState & {
  children?: ReactNode;
};

const ListItem: FC<ListItemProps> = props => {
  const listContext: ListItemState | undefined = useListContext();
  const { children, margin, padding, sx, variant } = props;

  const sxItem = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      ...listContext?.sx,
      ...sx,
      ...(getMargin(margin, listContext?.margin, { y: '0.75em' }) as SxProps<Theme>),
      ...(getPadding(padding, listContext?.padding) as SxProps<Theme>),
    }),
    [listContext?.sx, sx, listContext?.margin, margin, listContext?.padding, padding]
  );

  return (
    <Typography component='li' sx={sxItem} variant={variant || listContext?.variant}>
      {children}
    </Typography>
  );
};

export default ListItem;
